const state = {
  loading: false,
  loadedOnce: false,
  userloadedOnce: false,
  success: false,
  error: false,
  errorUser: false,
  userList: {},
  selectedUser: {},
  selectedUserSuccess: false,
  selectedUserError: false,
};

export default state;
